import { tabsON, poiON, rPlannerON } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/poiDirections';

window.tabsON = tabsON;
window.poiON = poiON;
window.rPlannerON = rPlannerON;
